import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import Header from './components/Header'
import Sidebar from './components/Sidebar'
import { useSelector, useDispatch } from 'react-redux'
import InputArea from './components/InputArea'
import ChatWindow from './components/ChatWindow'
import { messengerActions } from 'srcReact/MessengerPage/actions'
import { checkNested } from 'srcReact/helpers/validator'
import { urlSearchParams, isNativeIOS } from 'srcReact/helpers/utils'
import LightProfileProto from 'srcReact/components/common2/LightProfileModal/LightProfilPrototype'
import { lightProfileActions } from 'srcReact/components/common2/LightProfileModal/actions'
import useScrollToElement from 'srcReact/helpers/hooks/useScrollToElement'

const MessengerMobile = ({
  isMobile,
  isNative,
  isDesktop,
  isExpanded,
  setIsExpanded,
  fromLightProfile = false,
  fromQuickMessenger = false,
  messageToSend = '',
  fromFeed = false,
  fromProfile = false,
  userId = null,
  conversationId = null,
  setConversationId,
  closeMessengerPopup,
  closeLightProfile,
  setIsFileModalOpen,
  containerCSS
}) => {
  const { targetRefs, scrollToTarget } = useScrollToElement()

  const dispatch = useDispatch()
  const {
    organization: { current_organization },
    messenger: {
      sidebarScreenType,
      originMessage,
      isSidebarVisibile,
      isMainContentVisible,
      openedConversation,
      conversation
    }
  } = useSelector((state) => state)
  const [focusedMode, setFocusedMode] = useState(false)
  const [sendMsgOnLoad, setSendMsgOnLoad] = useState(false)
  const [newConvCreated, setNewConvCreated] = useState(false)

  useEffect(() => {
    return () => {
      if (fromLightProfile) {
        dispatch(messengerActions.setFromLightProfile(false))
      }
    }
  }, [])

  useEffect(() => {
    // nativeapp
    if (isNative && userId && (fromLightProfile || fromFeed) && urlSearchParams('organization_id')) {
      triggerActions(urlSearchParams('organization_id'))
    }
  }, [fromLightProfile, fromFeed, urlSearchParams('organization_id')])

  useEffect(() => {
    if (
      !isNative &&
      (userId || conversationId) &&
      (fromLightProfile || fromFeed || fromQuickMessenger) &&
      checkNested(current_organization, 'info', 'id') &&
      current_organization.info.id > 0
    ) {
      triggerActions(current_organization.info.id)
    }
  }, [fromLightProfile, fromFeed, fromQuickMessenger, current_organization?.info?.id, userId, conversationId, isNative])

  useEffect(() => {
    if (fromFeed && messageToSend.length > 0 && openedConversation && !sendMsgOnLoad && newConvCreated) {
      setSendMsgOnLoad(true)
      setNewConvCreated(false)
      dispatch(messengerActions.postMessage(openedConversation.conversation.id, messageToSend, null, null, null))
    }
  }, [fromFeed, messageToSend, openedConversation, sendMsgOnLoad])

  const triggerActions = (orgId) => {
    setNewConvCreated(true)
    if (fromQuickMessenger && conversationId > 0) {
      dispatch(messengerActions.getConversationOpen(null, conversationId))
    } else {
      dispatch(messengerActions.createConversation(orgId, userId.toString()))
    }
    dispatch(messengerActions.showMainContent(true))
    dispatch(messengerActions.showSidebar(false))
    dispatch(messengerActions.setFromLightProfile(fromLightProfile))
    dispatch(messengerActions.setOrganizationId(orgId))
  }

  const handleToggler = () => {
    if (isExpanded && sidebarScreenType === 'create') {
      dispatch(messengerActions.setSideBarScreenType('search'))
    }
    setIsExpanded(!isExpanded)
  }
  const showUserLightModal = (modalUser) => {
    const lp = new LightProfileProto()
    lp.userId = modalUser.id || modalUser.user_id
    dispatch(lightProfileActions.openLightProfileModal(lp))
  }

  return (
    <div className={styles.messangerWrapper}>
      {isSidebarVisibile && !fromLightProfile && !fromFeed && (
        <React.Fragment>
          <aside
            className={`${styles.sidebarContainer} ${!isExpanded && styles.sidebarContainerCollapsed} ${
              !isMobile && isExpanded && sidebarScreenType === 'create' && styles.sidebarContainerCreateConv
            }`}>
            <Sidebar
              isExpanded={isExpanded}
              onToggle={handleToggler}
              showUserLightModal={showUserLightModal}
              isMobile={isMobile}
              isDesktop={isDesktop}
              showBack={!fromQuickMessenger}
              fromQuickMessenger={fromQuickMessenger}
              setConversationId={setConversationId}
            />
          </aside>
        </React.Fragment>
      )}
      {(isMainContentVisible || fromLightProfile || fromFeed || (fromQuickMessenger && conversationId > 0)) && (
        <div
          className={`${styles.mainContainer} ${!isExpanded && styles.mainContainerWithCollapsed} ${
            !isMobile && isExpanded && sidebarScreenType === 'create' && styles.mainContainerWithCreateConv
          } ${containerCSS}`}>
          {openedConversation && (
            <React.Fragment>
              <header className={`${styles.headerContainer} ${isNativeIOS() && styles.isNativeIOS}`}>
                <Header
                  fromProfile={fromProfile}
                  fromFeed={fromFeed}
                  fromLightProfile={fromLightProfile}
                  closeLightProfile={closeLightProfile}
                  closeMessengerPopup={closeMessengerPopup}
                  fromQuickMessenger={fromQuickMessenger}
                  setConversationId={setConversationId}
                  closeQuickMessenger={closeMessengerPopup}
                />
              </header>

              <div
                className={`${styles.chatWindow} ${originMessage && styles.replyChatWindow} ${
                  isMobile && focusedMode && styles.hasFocusedMode
                } ${isNativeIOS() && styles.isNativeIOS}`}>
                <ChatWindow
                  isMobile={isMobile}
                  isDesktop={isDesktop}
                  isNative={isNative}
                  setIsFileModalOpen={setIsFileModalOpen}
                  targetRefs={targetRefs}
                  scrollToTarget={scrollToTarget}
                  fromQuickMessenger={fromQuickMessenger}
                />
              </div>
              {openedConversation ? (
                openedConversation.conversation.isLeftByUser === 1 ||
                openedConversation.conversation.hasBeenRemoved === 1 ? (
                  <div className={`${styles.inputAreaContainer} ${styles.inputAreaContainerEmpty}`}></div>
                ) : (
                  <div className={styles.inputAreaContainer}>
                    <InputArea
                      showEmoji={true}
                      showFileUpload={true}
                      isMobile={isMobile}
                      scrollToTarget={scrollToTarget}
                      focusedMode={focusedMode}
                      setFocusedMode={setFocusedMode}
                    />
                  </div>
                )
              ) : null}
            </React.Fragment>
          )}
          {/* {conversation.loaded && conversation.list.length === 0 && <EmptyConversation />} */}
        </div>
      )}
    </div>
  )
}

export default MessengerMobile
